import type { CwyTransferRequest } from '../services/walletService';

const statusById = new Map<string, string>();
const toastedKeys = new Set<string>();
let baselineReady = false;

export function resetTransferNotificationState(): void {
  statusById.clear();
  toastedKeys.clear();
  baselineReady = false;
}

export function seedTransferNotificationBaseline(requests: CwyTransferRequest[]): void {
  if (baselineReady) return;
  for (const req of requests) {
    statusById.set(req.transfer_request_id, req.status);
  }
  baselineReady = true;
}

export function getTransferStatusBaseline(id: string): string | undefined {
  return statusById.get(id);
}

export function setTransferStatusBaseline(id: string, status: string): void {
  statusById.set(id, status);
}

export function wasTransferToastShown(id: string, status: string): boolean {
  return toastedKeys.has(`${id}:${status}`);
}

export function markTransferToastShown(id: string, status: string): void {
  toastedKeys.add(`${id}:${status}`);
}
